import type { LinkResolverType } from '@landsbankinn/prismic';
import { Prismic, PrismicText, isEmptyText } from '@landsbankinn/prismic';
import { Icon, Segment } from '@landsbankinn/ui';
import React from 'react';
import { TileCard, TileLayout } from '../components/tiles/TileCard';
import { TilesGroup } from '../components/tiles/TilesGroup';

interface IProps {
  fields: IField[];
  linkResolver?: LinkResolverType;
  className?: string;
}

interface IField {
  number: Prismic.RichText;
  title: Prismic.RichText;
  copy: Prismic.RichText;
  icon: string;
  link: Prismic.Link;
  index: number;
  count: number;
}

export function getTileLayout(count: number, item: number) {
  // count 2
  if (count === 2 && item === 1) {
    return TileLayout.Horizontal;
  }

  // count 43
  if (count === 4 && (item === 1 || item === 4)) {
    return TileLayout.Horizontal;
  }

  // count 5
  if (count === 5 && item === 5) {
    return TileLayout.Horizontal;
  }

  // count 6
  if (count === 6 && (item === 1 || item === 4)) {
    return TileLayout.Horizontal;
  }

  if (count === 6 && item === 3) {
    return TileLayout.Vertical;
  }

  return null;
}

export const TileCardItem = ({
  number,
  title,
  copy,
  icon,
  index,
  count,
  ...rest
}: IField) => {
  const isEmpty = isEmptyText(copy);

  return (
    <TileCard
      number={Prismic.text(number)}
      title={Prismic.text(title)}
      copy={!isEmpty && <PrismicText value={copy} />}
      icon={<Icon name={icon} />}
      iconName={icon}
      layout={getTileLayout(count, index + 1)}
      {...rest}
    />
  );
};

export const TilesContainer = ({ fields, className }: IProps) => {
  const count = fields.length;
  return (
    <Segment isArticle className={className}>
      <TilesGroup count={count}>
        {fields?.map(({ count, ...rest }, index) => (
          <TileCardItem
            key={`tile-${index}`}
            count={fields.length}
            {...rest}
            index={index}
          />
        ))}
      </TilesGroup>
    </Segment>
  );
};
